import { isAllowedOrigin, normalizeOrigin } from './post-message/protocol';

const TRUTHY = new Set(['1', 'true', 'yes']);

// Resolves which parent origin (if any) the embedded app may talk to.
// The host origin must be on the build-time allowlist; when the browser
// exposes ancestorOrigins it must also match the real parent, so a page that
// frames the app with a forged ?hostOrigin= still gets no bridge.
export function resolveEmbedHost({ search = '', allowlist = [], ancestorOrigins = null, isFramed = false }) {
    const params = new URLSearchParams(search);
    const isEmbed = TRUTHY.has(String(params.get('embed') || '').toLowerCase());
    if (!isEmbed) return { isEmbed: false, hostOrigin: null, reason: null };
    if (!isFramed) return { isEmbed: true, hostOrigin: null, reason: 'not-framed' };

    const requested = params.get('hostOrigin');
    let candidate = requested ? normalizeOrigin(requested) : null;
    if (!requested && allowlist.length === 1) candidate = allowlist[0];
    if (!candidate || !isAllowedOrigin(candidate, allowlist)) {
        return { isEmbed: true, hostOrigin: null, reason: 'origin-not-allowed' };
    }

    const actualParent = ancestorOrigins && ancestorOrigins.length ? ancestorOrigins[0] : null;
    if (actualParent && actualParent !== candidate) {
        return { isEmbed: true, hostOrigin: null, reason: 'ancestor-mismatch' };
    }
    return { isEmbed: true, hostOrigin: candidate, reason: null };
}
